/**
 * 共創パートナー募集ステータス
 */
export const RecruitmentStatus = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  SCHEDULED: 'scheduled',
} as const

export type RecruitmentStatusValue = (typeof RecruitmentStatus)[keyof typeof RecruitmentStatus]

export const RecruitmentStatusValues = [
  { code: RecruitmentStatus.DRAFT, value: '下書き' },
  { code: RecruitmentStatus.PUBLISHED, value: '公開中' },
  { code: RecruitmentStatus.SCHEDULED, value: '予約投稿' },
]

export const RecruitmentStatusLabel = {
  [RecruitmentStatus.DRAFT]: '下書き',
  [RecruitmentStatus.PUBLISHED]: '公開中',
  [RecruitmentStatus.SCHEDULED]: '予約投稿',
}